<div class="row mb-4">
  <div class="bottom-table-head">
    <h4>Governance Body Details</h4>
    <p-button
      label="Add Governance Body Member"
      *appHasRole="[2, 3]"
      (click)="addCommitteeview()"
    />
  </div>
  <div class="row tab-input-data">
    <p-table
      [value]="Committee"
      [tableStyle]="{ 'min-width': '60rem' }"
      stripedRows
      class="tab-data-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="code" style="width: 20%">
            Name <p-sortIcon field="code" />
          </th>
          <th pSortableColumn="name" style="width: 20%">
            Mobile <p-sortIcon field="name" />
          </th>

          <th pSortableColumn="quantity" style="width: 20%">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-Committee>
        <tr>
          <td>{{ Committee.firstName }} {{ Committee.lastName }}</td>
          <td>{{ Committee.phoneNumber }}</td>
          <td>
            <div class="d-flex gap-3 action-btns">
            <img src="assets/images/icon-edit.svg" (click)="editCommittee(Committee)" *appHasRole="[2, 3]">
            <img src="assets/images/icon-delete.svg" (click)="deleteCommittee(Committee)" *appHasRole="[2, 3]">
          </div>
            
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="sidebarVisible"
  position="right"
  [showCloseIcon]="false"
>
  <form
    [formGroup]="updatecommitteeForm"
    *ngIf="sidebarVisible"
    (ngSubmit)="updatecommittee()"
  >
    <div class="tab-pop-txt">
      <h4>{{ addEditText }}</h4>
      <i class="pi pi-times" (click)="sidebarVisible = false"></i>
    </div>
    <div class="pop-data-set">
      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">First Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="firstName"
            formControlName="firstName"
            aria-describedby="firstName"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Last Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="lastName"
            formControlName="lastName"
            aria-describedby="lastName"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Father Name</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="fatherName"
            formControlName="fatherName"
            aria-describedby="fatherName"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">e-mail</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="email"
            formControlName="email"
            aria-describedby="email"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Village</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="villageId"
            formControlName="villageId"
            aria-describedby="villageId"
            readonly="true"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Mobile</div>
        <div class="project-detail-set-v mt-2">
          <p-inputNumber
            id="Mobile"
            mode="decimal"
            formControlName="Mobile"
            inputId="withoutgrouping"
            [useGrouping]="false"
          />
        </div>
      </div>
    </div>
    <div class="tab-footer-btns">
      <p-button
        label="Cancel "
        (click)="sidebarVisible = false; editCommitee = false"
        class="cancel-btn"
      />
      <p-button
        label="Add"
        type="submit"
        class="submit-btn"
        [disabled]="!updatecommitteeForm.valid"
      />
    </div>
  </form>
</p-sidebar>
